import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { Noise } from './Animations';
import { HaloBanner } from './HaloBanner';
export function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return <div className="min-h-screen flex flex-col bg-picus-bg text-picus-text" data-id="element-366">
      <Noise data-id="element-367" />
      <HaloBanner data-id="element-368" />
      <Navbar data-id="element-369" />
      <main className="flex-grow" data-id="element-370">{children}</main>
      <Footer data-id="element-371" />
    </div>;
}